export const generateRandomPassword = ({ passwordLength = 20 } = {}): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?'
  let randomPassword = ''
  for (let i = 0; i < passwordLength; i++) {
    const index = Math.floor(Math.random() * characters.length)
    randomPassword += characters[index]
  }
  return randomPassword
}
